import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CountryService from "../../../../services/catalogs/CountryService";

export const REQUEST_UPDATE_COUNTRY = "REQUEST_UPDATE_COUNTRY";
export const UPDATE_COUNTRY_SUCCESS = "UPDATE_COUNTRY_SUCCESS";
export const UPDATE_COUNTRY_ERROR = "UPDATE_COUNTRY_ERROR";

function requestUpdateCountry() {
  return {
    type: REQUEST_UPDATE_COUNTRY,
  };
}

function updateCountrySuccess(json) {
  return {
    type: UPDATE_COUNTRY_SUCCESS,
    message: json.data,
  };
}

function updateCountryError(json) {
  return {
    type: UPDATE_COUNTRY_ERROR,
    error: json.data,
  };
}

export function updateCountry(country_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateCountry());
    return CountryService.putCountry(country_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateCountrySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateCountry(country_id, payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateCountryError(json.data));
      }
    });
  };
}
